import type { ReactNode } from 'react';

interface Props {
  label: ReactNode;
  children: ReactNode;
  className?: string;
}

/**
 * Tooltip simples por CSS (group-hover): o wrapper `.group` recebe o hover. Pra
 * funcionar sobre um filho `disabled`, dê `pointer-events-none` ao filho — assim
 * o ponteiro "atravessa" pro wrapper e o group-hover dispara (botão disabled
 * sozinho não propaga hover de forma confiável entre browsers).
 */
export function Tooltip({ label, children, className }: Props) {
  return (
    <span className={'group relative inline-flex ' + (className ?? '')}>
      {children}
      <span
        role="tooltip"
        className="border-ink-700 bg-ink-950 text-ink-200 pointer-events-none absolute bottom-full left-1/2 z-30 mb-2 w-max max-w-xs -translate-x-1/2 rounded-md border px-3 py-2 text-xs leading-snug opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100"
      >
        {label}
      </span>
    </span>
  );
}
